import { RootStore } from '@vromo/dashboard/src/stores/RootStore';
import { useStore } from '@vromo/mobx-react/mobx-react';
import Button from '@vromo/ui/components/Button';
import Modal, { ModalActions, ModalContent, ModalHeader } from '@vromo/ui/components/Modal';
import Title from '@vromo/ui/components/Title';
import last from 'lodash/last';
import { observer } from 'mobx-react-lite';
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChatHistoryItem, JobHistoryResponse } from '../../helpers/JobHistoryHelper';
import styles from './chatHistoryModal.style';
import ChatGroup from './components/ChatGroup';

interface Props {
    isOpen: boolean;
    selectedJob?: JobHistoryResponse;
    onClose: () => void;
}

const ChatHistoryModal = observer<Props>(({ isOpen, selectedJob, onClose }) => {
    const { t } = useTranslation();
    const [dashboardUserIds, setDashboardUserIds] = useState<number[]>([]);

    const {
        authStore: { graph, role }
    } = useStore<RootStore>('rootStore');

    useEffect(() => {
        graph.root
            .graph()
            .roles(role.id)
            .account()
            .roles()
            .get()
            .then(({ items }) => {
                setDashboardUserIds(items.map((r) => r.user?.id || 0));
            });
    }, []);

    const chatGroups =
        selectedJob?.chat.reduce(
            (groups: ChatHistoryItem[][], chat) => {
                const lastGroup = last(groups);

                if (!lastGroup?.length) {
                    groups[groups.length - 1]!.push(chat);
                    return groups;
                }

                const lastUserId = last(lastGroup)?.fromUser.id;
                lastUserId === chat.fromUser.id
                    ? groups[groups.length - 1]!.push(chat)
                    : groups.push([chat]);
                return groups;
            },
            [[]]
        ) || [];

    return (
        <Modal isOpen={isOpen} onRequestClose={onClose}>
            <ModalHeader>
                <Title>{t('jobHistory.chatHistory')}</Title>
            </ModalHeader>
            <ModalContent style={styles.modalContent}>
                {selectedJob && selectedJob?.chat.length > 0 ? (
                    <div style={styles.chatWindowContainer}>
                        {chatGroups.map((chatGroup) => (
                            <ChatGroup {...{ chatGroup, dashboardUserIds }} />
                        ))}
                    </div>
                ) : (
                    <div style={styles.emptyContent}>{t('jobHistory.noChat')}</div>
                )}
            </ModalContent>
            <ModalActions>
                <Button onClick={onClose}>{t('jobHistory.close')}</Button>
            </ModalActions>
        </Modal>
    );
});

export default memo(ChatHistoryModal);
